import React, {useRef, useCallback} from 'react'
import './Animation.scss'
import lottie from 'lottie-web'
import flytoget from '../../../assets/lottie/flytoget.lottie.json'
import foyen from '../../../assets/lottie/foyen.lottie.json'
import usbl from '../../../assets/lottie/usbl.lottie.json'
import help from '../../../assets/lottie/help.lottie.json'
import skagerak from '../../../assets/lottie/skagerak.lottie.json'
import sands from '../../../assets/lottie/sands.lottie.json'
import kreftforeningen from '../../../assets/lottie/kreftforeningen.lottie.json'
import kongsberg from '../../../assets/lottie/kongsberg.lottie.json'
import avinor from '../../../assets/lottie/avinor.lottie.json'
import obos from '../../../assets/lottie/obos.lottie.json'
import lis from '../../../assets/lottie/lis.lottie.json'
import moller from '../../../assets/lottie/moller.lottie.json'
import lovdataLogo from '../../../assets/lottie/lovdata-2-reveal.lottie.json'

const animations = {
	flytoget: flytoget,
	foyen: foyen,
	usbl: usbl,
	help: help,
	skagerak: skagerak,
	sands: sands,
	kreftforeningen: kreftforeningen,
	kongsberg: kongsberg,
	avinor: avinor,
	obos: obos,
	lis: lis,
	moller: moller,
	lovdataLogo: lovdataLogo
}

const Animation = ({animationname}) => {

	const animation = useRef(null)

	const container = useCallback(node => {
		if(node !== null) {
			animation.current = lottie.loadAnimation({
				container: node,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				animationData: animations[animationname] ? animations[animationname] : null
			 });
		}
	}, [animationname])

	return(
		<div className="Animation">
			<div className="animation" ref={container} />
		</div>
	)
}

export default Animation